import { Quasar } from 'quasar'
export const setQuasarInternalLanguage = (qLang) => {
  if (qLang !== 'en-us') qLang = qLang.split('-')[0]
  import(
    /* webpackInclude: /(ru|en-us)\.js$/ */
    `quasar/lang/${qLang}`
  ).then(lang => {
    Quasar.lang.set(lang.default)
  })
}
